export default __webpack_public_path__ + "static/media/SENAIT_NL_SEQ15.ddde30f7.mp3";